import React from "react";
import { CATEGORY_TILES } from "@/mock";
import { ArrowUpRight } from "lucide-react";

const CategoryTiles = () => {
  return (
    <section className="bg-[#0b0b0c] py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="text-[#c9a24a] uppercase text-[11px] tracking-[0.4em] mb-4">
              Shop by space
            </div>
            <h2 className="font-serif text-[#f4ead5] text-4xl md:text-5xl">
              Two ways to <span className="italic">glow</span>
            </h2>
          </div>
          <a
            href="#edit"
            className="hidden md:inline-flex items-center gap-2 text-[#e9d9b0] hover:text-[#c9a24a] text-sm transition-colors"
          >
            Shop everything <ArrowUpRight size={16} />
          </a>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {CATEGORY_TILES.map((t) => (
            <a
              key={t.id}
              href={`#${t.id}`}
              className="group relative block overflow-hidden bg-[#111112] border border-[#1c1c1e]"
            >
              <div className="relative aspect-[4/5] md:aspect-[5/6] overflow-hidden">
                <img
                  src={t.image}
                  alt={t.title}
                  className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[1200ms] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0c]/95 via-[#0b0b0c]/20 to-transparent" />
              </div>
              <div className="absolute inset-0 flex flex-col justify-between p-8">
                <div className="font-serif text-[#c9a24a] text-6xl">{t.letter}</div>
                <div>
                  <div className="text-[#a9a294] uppercase text-[11px] tracking-[0.3em] mb-2">
                    {t.title}
                  </div>
                  <div className="flex items-end justify-between">
                    <div className="font-serif text-[#f4ead5] text-4xl md:text-5xl">
                      {t.label}
                    </div>
                    <span className="inline-flex items-center gap-2 text-[#e9d9b0] group-hover:text-[#c9a24a] text-sm transition-colors">
                      {t.cta}
                      <ArrowUpRight
                        size={16}
                        className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryTiles;
